import { render, staticRenderFns } from "./fcwpDefaultContent.vue?vue&type=template&id=2bb7a524&"
import script from "./fcwpDefaultContent.vue?vue&type=script&lang=js&"
export * from "./fcwpDefaultContent.vue?vue&type=script&lang=js&"
import style0 from "./fcwpDefaultContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports